import React, {useEffect, useRef, useState} from 'react';
import './Client.scss';
import * as _ from "lodash";
import {useAuth0} from "../../utils/providers/Auth0Provider";
import {Helmet} from 'react-helmet';
import {compose} from "redux";
import {connect} from "react-redux";
import {openConfirmationModal, toggleLoading} from "../../redux/reducers/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {DOCUMENT_CATEGORIES, OWNER, USER_ICON_MAPPING} from "../../config/constants";
import Tooltip from "@material-ui/core/Tooltip";
import * as moment from "moment";
import Paper from "@material-ui/core/Paper";
import VaultStatus from "../Vault/VaultStatus";
import Divider from "@material-ui/core/Divider";
import VaultDetails from "../Vault/VaultDetails";
import VaultActivity from "../Vault/VaultActivity";
import Button from "@material-ui/core/Button";
import routes, {BASE_ROUTE} from "../../utils/api-client";
import useWindowDimensions, {humanFileSize} from "../../utils/helpers";
import {DashboardModal} from "@uppy/react";
import {Uppy} from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import axios from "axios";
import {navigate} from "@reach/router";
import VaultCard from "../Dashboard/components/VaultCard";

function Client(props) {
  let [client, setClient] = useState();
  let documentCategoryType = useRef();
  let userId = useRef();
  let [tempDocuments, setTempDocuments] = useState(null);
  let [openFileUploadModal, setOpenFileUploadModal] = useState(false);
  const { height, width } = useWindowDimensions();
  let [vaultBuffer, setVaultBuffer] = useState(1);

  const { loading } = useAuth0();

  useEffect(() => {
    if (width < 570) {
      setVaultBuffer(1);
    } else if (width < 792) {
      setVaultBuffer(2);
    } else if (width < 1024) {
      setVaultBuffer(3);
    } else if (width < 1124) {
      setVaultBuffer(2);
    } else if (width < 1352) {
      setVaultBuffer(3);
    } else {
      setVaultBuffer(4);
    }
  }, [width]);

  let [uppy, setUppy] = useState( new Uppy({
    autoProceed: true,
    resetProgress: true,
    restrictions: {
      maxFileSize: 10**8, // 100MB restriction
      maxNumberOfFiles: 30,
      minNumberOfFiles: 1,
      allowedFileTypes: false
    }}).use(AwsS3, {
    getUploadParameters(file) {
      const data = {
        file_name: file.name,
        file_type: file.type,
        user_id: props.clientId,
        category_type: 'ADVISOR',
        category_id: userId.current,
        category_sub_type: documentCategoryType.current,
      };
      // if no vault exists, store the file in a temp dir w/ UUID
      return axios.post(BASE_ROUTE + "document_category_presigned_url", data).then((response) => {
        return {
          method: "put",
          url: response.data
        }
      })
    }
  }));

  useEffect(() => {
    uppy.on('complete', (result) => {
      if (result.successful.length) {
        props.toggleLoading(true);
        const newDocuments = _.map(result.successful, file => {
          return {
            name: file.name,
            type: file.type,
            size: file.size,
            updated: (new Date()).toUTCString()
          }});
        routes.updateDocumentCategory(props.clientId, "ADVISOR", userId.current, documentCategoryType.current, newDocuments).subscribe((response) => {
          props.toggleLoading(false);
          setTempDocuments(response.data);
        });
      }
    });
  }, []);

  useEffect(() => {
    if (tempDocuments) {
      const newClient = {
        ...client
      };
      const index = _.findIndex(newClient.document_categories, (category) => {console.log(category, documentCategoryType.current); return category.type === documentCategoryType.current});
      newClient.document_categories[index] = tempDocuments;
      setClient(newClient);
      uppy.reset();
      setOpenFileUploadModal(false);
    }
  }, [tempDocuments]);


  useEffect(() => {
    if (props.user) {
      userId.current = props.user.id;
      props.toggleLoading(true);
      routes.getClient(props.clientId).subscribe((response) => {
        setClient(response.data)
        props.toggleLoading(false);
      });
    }
  }, [props.user]);


  return (
    !!client &&
    <div className="client">
      <Helmet>
        <title>Fidelius Vaults: Client {client.name}</title>
      </Helmet>
      <div className="relative vault-content-outer-container">
        <p className="text-white bottom-spacer-small faded">Client Details:</p>
        <p className="text-white vault-name-text text-3xl md:text-5xl">{ client.name }</p>
        <div className="vault-name-divider bottom-spacer mt-3"/>
        <div className="flex items-center mb-3  ">
          <FontAwesomeIcon icon={'user'} className="text-primary mr-2 text-lg md:text-xl"/>
          <p className="text-lg md:text-xl font-bold text-white">You're the <span className="text-primary">advisor</span> of this client.</p>
        </div>
        <div className="md:absolute vault-details-outer-container text-white mb-4 md:mb-0 text-sm md:text-base">
          <div className="flex items-center">
            <div className="font-bold vault-detail-title">Email:</div>
            <div className="flex items-center">
              <p>{client.email}</p>
              <Tooltip enterTouchDelay={50} title={`Click to send an email to ${client.name}`}>
                <a onClick={() => window.location = `mailto:${client.email}`}>
                  <FontAwesomeIcon icon="envelope" className="text-primary ml-2 cursor-pointer"/>
                </a>
              </Tooltip>

            </div>
          </div>
          <div className="md:mb-2 flex items-center">
            <div className="font-bold vault-detail-title">Phone:</div>
            { client.phone }
          </div>
          <div className="flex items-center">
            <div className="font-bold vault-detail-title">Created:</div>
            {/*{ moment(vault.created).format('LLL') }*/}
          </div>
          <div className="flex items-center">
            <div className="font-bold vault-detail-title">Updated:</div>
            { moment(client.updated).format('LLL') }
          </div>
        </div>
        {
          client.notes &&
          <Tooltip title={client.notes} enterTouchDelay={50}>
            <p className="text-white hover:text-opacity-100 cursor-pointer text-opacity-50 text-sm md:text-base vault-description-text">{ client.notes }</p>
          </Tooltip>
        }

        <Paper className="mt-12">
          <div className="sm:flex sm:items-center">
            <div className="sub-title-description-container text-left">
              <p className="text-2xl">Vaults</p>
            </div>
            <div className="title-divider mt-3 mb-5 sm:mt-0 sm:mb-0"/>
            <div className="sm:ml-6">
              <Button
                variant="contained"
                className="w-full sm:w-auto"
                onClick={() => navigate(`/clients/${client.id}/create-vault`)}

                color="primary">
                      <span className="flex items-center">
                        <FontAwesomeIcon icon="plus" className="mr-2"/>
                        <p>Create Vault</p>
                      </span>
              </Button>
            </div>
          </div>

          {
            client.vaults.length ?
              <div className="flex items-center flex-wrap justify-around mb-4">
                {_.map(client.vaults, vault => <VaultCard key={vault.id} vault={vault}/>)}
                {
                  !!((client.vaults.length) % vaultBuffer) &&
                  _.map(new Array( vaultBuffer - (client.vaults.length) % vaultBuffer), (i) => {
                    return <div key={i} className="empty-vault-card"/>
                  })
                }
              </div>
              :
              <div className="flex items-center text-center justify-center missing-other-vaults">
                <div className="mt-3">
                  <p className="text-grey text-xl">No Vaults Found.</p>
                </div>
              </div>
          }

          <div className="sm:flex sm:items-center">
            <div className="sub-title-description-container text-left">
              <p className="text-2xl">Documents</p>
            </div>
            <div className="title-divider mt-3 mb-5 sm:mt-0 sm:mb-0"/>
          </div>

          {
            client.document_categories.length ?
              <>
                {
                  _.map(client.document_categories, (category) => {
                    return <div className="document-category-container">
                      <div className="flex justify-between">
                        <div>
                          <p className="text-lg">{DOCUMENT_CATEGORIES[category.type].title}</p>
                          <p className="">{DOCUMENT_CATEGORIES[category.type].description}</p>
                        </div>
                        <Button
                          variant="contained"
                          className="w-full sm:w-auto small-button"
                          onClick={() => {documentCategoryType.current = category.type; setOpenFileUploadModal(true)}}
                          color="secondary">
                           Upload
                        </Button>
                      </div>
                      {
                        !!category.documents.length ?
                          <div className="mt-4">
                            <div className="vault-detail-header-row flex text-sm">
                              <p className="documents-name-field font-bold hidden sm:block">File Name</p>
                              <p className="font-bold hidden sm:block">Uploaded</p>
                            </div>
                            {
                              _.map(_.orderBy(category.documents, (document) => moment(document.updated), ['desc']), (document, index) =>
                                <div key={index}
                                     className={`vault-detail-table-row flex flex-col sm:flex-row sm:items-center cursor-pointer text-primary`}
                                  // onClick={() => routes.downloadVaultFile(vault.id, document.name)}
                                >
                                  <p className="documents-name-field">
                                    { document.name }
                                    <span className="text-xs md:text-sm text-grey ml-2">({ humanFileSize(document.size) })</span>
                                  </p>
                                  <div className="flex-1">
                                    <p className="text-grey mt-2 sm:mt-0 text-sm">{ moment(document.updated).format('L LT') }</p>
                                  </div>
                                </div>
                              )
                            }
                          </div> :
                          <div className="flex items-center justify-center text-grey w-full mt-6 mb-2">
                            No Documents Found
                          </div>
                      }
                    </div>
                  })
                }
              </> :
              <div className="flex items-center text-center justify-center missing-other-vaults">
                <div className="mt-3">
                  <p className="text-grey text-xl">No Documents Found.</p>
                </div>
              </div>
          }

          <div className="sm:flex sm:items-center">
            <div className="sub-title-description-container text-left">
              <p className="text-2xl">Event Log</p>
            </div>
            <div className="title-divider mt-3 mb-5 sm:mt-0 sm:mb-0"/>
          </div>

          <div className="flex items-center text-center justify-center missing-other-vaults">
            <div className="mt-3">
              <p className="text-grey text-xl">No Activity Found.</p>
            </div>
          </div>
        </Paper>
      </div>

      {
        openFileUploadModal &&
        <DashboardModal
          uppy={uppy}
          open={openFileUploadModal}
          target={document.body}
          onRequestClose={() => setOpenFileUploadModal(false)}
          proudlyDisplayPoweredByUppy={false}
          metaFields={[
            { id: 'name', name: 'Name', placeholder: 'File name' }
          ]}
        />
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading, openConfirmationModal }
  )
)(Client);

